import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SortableHeader from '../../components/SortableHeader';
import KeyStar from '../../components/KeyStar';
import { bulkUpdateContacts } from '../../api';
import {
  Edit,
  Trash2,
  Plus,
} from 'lucide-react';

function AccountContactsTab({
  accountId,
  sortedContacts,
  contactsSort,
  handleContactsSort,
  canDo,
  handleOpenContactModal,
  setContactToDelete,
  setShowDeleteContactConfirm,
  reloadAccount,
}) {
  const [error, setError] = useState('');

  // The star saves at once; the account re-reads so the Key sort follows.
  const toggleKeyContact = async (contact, on) => {
    try {
      await bulkUpdateContacts([contact.id], { is_key_contact: on });
      setError('');
      if (reloadAccount) await reloadAccount();
    } catch (err) { setError(err.response?.data?.error || 'Could not update the key-contact flag'); }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Contacts</h3>
        {canDo('contacts', 'create') && (
          <button className="btn btn-primary btn-sm" onClick={() => handleOpenContactModal()}>
            <Plus size={16} />
            Add Contact
          </button>
        )}
      </div>
      {error && <div className="alert alert-error" role="alert">{error}</div>}
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <SortableHeader label="Key" field="is_key_contact" sortField={contactsSort.field} sortDirection={contactsSort.direction} onSort={handleContactsSort} />
              <SortableHeader label="Name" field="name" sortField={contactsSort.field} sortDirection={contactsSort.direction} onSort={handleContactsSort} />
              <SortableHeader label="Email" field="email" sortField={contactsSort.field} sortDirection={contactsSort.direction} onSort={handleContactsSort} />
              <SortableHeader label="Phone" field="phone" sortField={contactsSort.field} sortDirection={contactsSort.direction} onSort={handleContactsSort} />
              <SortableHeader label="Job Title" field="job_title" sortField={contactsSort.field} sortDirection={contactsSort.direction} onSort={handleContactsSort} />
              <SortableHeader label="Status" field="active" sortField={contactsSort.field} sortDirection={contactsSort.direction} onSort={handleContactsSort} />
              {(canDo('contacts', 'edit') || canDo('contacts', 'delete')) && <th style={{ width: '80px' }}>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {sortedContacts.length > 0 ? (
              sortedContacts.map(contact => (
                <tr key={contact.id}>
                  <td>
                    <KeyStar on={!!contact.is_key_contact} name={contact.name} onToggle={canDo('contacts', 'edit') ? (on) => toggleKeyContact(contact, on) : undefined} />
                  </td>
                  <td>
                    <Link to={`/contacts/${contact.id}`} state={{ fromAccount: accountId }}>{contact.name}</Link>
                  </td>
                  <td>{contact.email || '-'}</td>
                  <td>{contact.phone || '-'}</td>
                  <td>{contact.job_title || '-'}</td>
                  <td>
                    <span className={`badge ${contact.active ? 'badge-success' : 'badge-gray'}`}>
                      {contact.active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  {(canDo('contacts', 'edit') || canDo('contacts', 'delete')) && (
                    <td>
                      <div className="flex gap-1">
                        {canDo('contacts', 'edit') && (
                          <button
                            className="btn btn-icon btn-sm"
                            onClick={() => handleOpenContactModal(contact)}
                            title="Edit"
                          >
                            <Edit size={14} />
                          </button>
                        )}
                        {canDo('contacts', 'delete') && (
                          <button
                            className="btn btn-icon btn-sm"
                            onClick={() => {
                              setContactToDelete(contact);
                              setShowDeleteContactConfirm(true);
                            }}
                            title="Delete"
                          >
                            <Trash2 size={14} />
                          </button>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={(canDo('contacts', 'edit') || canDo('contacts', 'delete')) ? 7 : 6} className="text-center text-secondary">No contacts</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AccountContactsTab;
